import * as z from 'zod/v4';

const industryV2Schema = z
  .object({
    industry: z.string(),
    subindustry: z.string(),
  })
  .partial();

const companySchema = z
  .object({
    company_match: z.string(),
    additional_comment: z.string(),
    companyId: z.string(),
    domain: z.string(),
    name: z.string(),
    region: z.string(),
    country: z.string(),
    state: z.string(),
    city: z.string(),
    industry: z.string(),
    country_iso_code: z.string(),
    address: z.string(),
    zip: z.string(),
    phone: z.string(),
    employee_range: z.string(),
    revenue_range: z.string(),
    employee_count: z.coerce.number(),
    annual_revenue: z.coerce.number(),
    is_blacklisted: z.boolean(),
    is_6qa: z.boolean(),
    geoIP_country: z.string(),
    geoIP_state: z.string(),
    geoIP_city: z.string(),
    state_code: z.string(),
    industry_v2: z.array(industryV2Schema),
    sic_description: z.string(),
    sic: z.string(),
    naics: z.string(),
    naics_description: z.string(),
  })
  .partial();

const scoreSchema = z
  .object({
    is_6qa: z.boolean(),
    product: z.string(),
    product_display_name: z.string(),
    intent_score: z.number(),
    buying_stage: z.string(),
    profile_score: z.number(),
    profile_fit: z.string(),
  })
  .partial();

const segmentItemSchema = z
  .object({
    name: z.string(),
    id: z.number(),
  })
  .partial();

const segmentsSchema = z
  .object({
    ids: z.array(z.number()),
    names: z.array(z.string()),
    list: z.array(segmentItemSchema),
  })
  .partial();

export const personalizationAttributesSchema = z.object({
  company: companySchema,
  scores: z.array(scoreSchema),
  segments: segmentsSchema,
  confidence: z.string(),
});

export type PersonalizationAttributes = z.infer<typeof personalizationAttributesSchema>;
